module.exports = __webpack_public_path__ + "static/media/animal-track.af8983c1.jpg";